import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "@/api/errors";

/**
 * Shared QueryClient. staleTime defaults to 30s — most resources are short-poll
 * and we rely on SSE for real-time updates (UI_PLAN §6).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});
